import { Button, Card, CardBody, CardFooter, CardHeader, CardHeading, LinkButton, Loading } from "@dgs/core";
import { FC, ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface Props {
	variant?: "elevated" | "outlined";
	title: string;
	children: ReactNode;
	prevLink?: string;
	onSubmitClick?: () => void;
	isLoading?: boolean;
	backButtonTitle?: string;
	submitButtonTitle?: string;
}

const StyledCardFooter = styled(CardFooter)`
	display: flex;
`;

const Spacer = styled.div`
	flex: 1;
`;

const CardWrapper = styled.div``;

export const EventOffboardingFormCard: FC<Props> = ({
	variant,
	onSubmitClick,
	prevLink,
	title,
	children,
	submitButtonTitle,
	backButtonTitle,
	isLoading = false,
}) => {
	const { t } = useTranslation();

	useEffect(() => {
		const listener = (e: KeyboardEvent) => {
			if (e.key === "Enter") {
				onSubmitClick && onSubmitClick();
			}
		};
		document.addEventListener("keyup", listener);

		return () => document.removeEventListener("keyup", listener);
	}, [onSubmitClick]);

	return (
		<CardWrapper>
			<Card $variant={variant}>
				<CardHeader>
					<CardHeading>{title}</CardHeading>
				</CardHeader>
				<CardBody>{children}</CardBody>
				<StyledCardFooter>
					{prevLink && (
						<LinkButton to={prevLink} type="button">
							{backButtonTitle || t("Previous")}
						</LinkButton>
					)}
					<Spacer />
					{onSubmitClick && (
						<Button
							prefix={isLoading && <Loading variant="tiny" color="current" />}
							disabled={isLoading}
							color="primary"
							onClick={onSubmitClick}
							type="button"
						>
							{submitButtonTitle || t("Submit")}
						</Button>
					)}
				</StyledCardFooter>
			</Card>
		</CardWrapper>
	);
};
